<script setup>
const isOpen = ref(false);
const previewUrl = ref("");

const openDialog = (payload) => {
  const url =
    typeof payload === "string" ? payload : (payload?.imageUrl ?? payload?.url);

  if (!url) {
    console.warn("AvatarPreviewDialog requires an image url to open.");
    return;
  }

  previewUrl.value = url;
  isOpen.value = true;
};

const closeDialog = () => {
  isOpen.value = false;
};

watch(isOpen, (value) => {
  if (!value) {
    previewUrl.value = "";
  }
});

defineExpose({
  openDialog,
  closeDialog,
});
</script>

<template>
  <v-dialog
    v-model="isOpen"
    fullscreen
    scrim="rgba(0, 0, 0, 0.85)"
    transition="fade-transition"
    content-class="!tw-bg-transparent"
  >
    <div
      class="tw-relative tw-w-screen tw-h-screen tw-bg-black/80 tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
      @click="closeDialog"
    >
      <dialog-close-btn
        :icon="'mdi-close-circle-outline'"
        :iconSize="'32'"
        @onSubmitButton="closeDialog"
      />

      <div
        class="tw-w-full tw-h-full tw-max-w-[400px] tw-max-h-[400px] tw-aspect-square tw-flex tw-items-center"
      >
        <div class="tw-m-4 tw-w-full tw-h-full">
          <v-img
            v-if="previewUrl"
            :src="previewUrl"
            class="tw-rounded-2xl tw-w-full tw-h-full"
            contain
            @click.stop
          />

          <div
            v-else
            class="tw-text-white tw-text-center tw-text-lg tw-font-semibold"
          >
            Unable to load avatar.
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
